module.exports = __webpack_public_path__ + "assets/img/tx21.433ae6fc.jpg";